import * as React from "react";
import { useMemo, useContext } from "react";
import useEmblaCarousel from "embla-carousel-react";
import CarouselContext from "./CarouselContext";
const CarouselProvider = ({ carouselId, children = void 0, options = {} }) => {
  const existingContextValue = useContext(CarouselContext);
  const [ref, api] = useEmblaCarousel(options);
  const value = useMemo(
    () => ({
      ...existingContextValue != null ? existingContextValue : {},
      [carouselId]: { ref, api }
    }),
    [api, carouselId, existingContextValue, ref]
  );
  return /* @__PURE__ */ React.createElement(CarouselContext.Provider, { value }, children);
};
export default CarouselProvider;
